module.exports = __webpack_public_path__ + "static/media/networkopt.821d0301.jpg";